export default {
	BAR_MANAGER: 'Bar Manager',
	REGIONAL_MANAGER: 'Regional Manager',
	AREA_MANAGER: 'Area Manager',
	MARKET_MANAGER: 'Market Manager',
	REGIONAL_DIRECTOR: 'Regional Director',
}; 